"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var idCounter = 0;

exports.default = function (prefix) {
    var id = ++idCounter;
    return "" + prefix + id;
};